import React from 'react';
import type { Region } from '@internal/backstage-plugin-bidone-backend';
import type { BDirectRow } from '../../../hooks/useBDirectRows';
import { DeployedCheckbox, RegionDash, RegionTag } from './styles';

// Read-only preprod-env counterpart to RegionCell. Used by the
// AUE-PREPROD / WEU-PREPROD columns — these always show what's deployed
// in `preprod` regardless of the release's target env (prod / uat), and
// never accept user input.
//
// Display rules (mirror the Azure-driven branch of RegionCell, scoped to
// preprod):
//   - Non-repo row → `—` (preprod isn't part of the template's
//     UAT/PROD checkbox dimension, so there's nothing to render).
//   - Repo row, no preprod tag → `—`.
//   - Repo row, preprod tag matches release name → ticked deployed badge.
//   - Repo row, preprod tag differs → render the actual tag label so the
//     user can see "preprod is on <X>, release is <Y>".
export const PreprodRegionCell: React.FC<{
  row: BDirectRow;
  region: Region;
  release: string;
}> = ({ row, region, release }) => {
  if (!row.repo) return <RegionDash>—</RegionDash>;
  const tag = row.perRegionPreprodTag[region.toLowerCase()];
  if (!tag) return <RegionDash>—</RegionDash>;
  const deployed = tag.toLowerCase() === release.toLowerCase();
  if (!deployed) return <RegionTag>{tag}</RegionTag>;
  return <DeployedCheckbox checked color="primary" size="small" disabled />;
};
